/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ICreateInternalRegulationObligationRuleMutationVariables = Types.Exact<{
  input: Types.ICreateInternalRegulationObligationRuleInput;
}>;

export type ICreateInternalRegulationObligationRuleMutation = {
  __typename?: 'Mutation';
  createInternalRegulationObligationRule: {
    __typename?: 'InternalRegulationObligationRule';
    id: string;
    name: string;
    obligationId: string;
    reviewStatus?: Types.IInternalRegulationObligationRuleReviewStatus | null;
  };
};

export const CreateInternalRegulationObligationRuleDocument = gql`
  mutation CreateInternalRegulationObligationRule($input: CreateInternalRegulationObligationRuleInput!) {
    createInternalRegulationObligationRule(input: $input) {
      id
      name
      obligationId
      reviewStatus
    }
  }
`;
export type ICreateInternalRegulationObligationRuleMutationFn = Apollo.MutationFunction<
  ICreateInternalRegulationObligationRuleMutation,
  ICreateInternalRegulationObligationRuleMutationVariables
>;

/**
 * __useCreateInternalRegulationObligationRuleMutation__
 *
 * To run a mutation, you first call `useCreateInternalRegulationObligationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalRegulationObligationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalRegulationObligationRuleMutation, { data, loading, error }] = useCreateInternalRegulationObligationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalRegulationObligationRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateInternalRegulationObligationRuleMutation,
    ICreateInternalRegulationObligationRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ICreateInternalRegulationObligationRuleMutation,
    ICreateInternalRegulationObligationRuleMutationVariables
  >(CreateInternalRegulationObligationRuleDocument, options);
}
export type CreateInternalRegulationObligationRuleMutationHookResult = ReturnType<
  typeof useCreateInternalRegulationObligationRuleMutation
>;
export type CreateInternalRegulationObligationRuleMutationResult =
  Apollo.MutationResult<ICreateInternalRegulationObligationRuleMutation>;
export type CreateInternalRegulationObligationRuleMutationOptions = Apollo.BaseMutationOptions<
  ICreateInternalRegulationObligationRuleMutation,
  ICreateInternalRegulationObligationRuleMutationVariables
>;
